<template>
<div class="table-row-lite">
  <div class="table-td-lite w150">
    {{payment.order_number}}
  </div>
  <div class="table-td-lite w150">
    {{payment.delivery_type}}
  </div>
  <div class="table-td-lite w250">
    {{payment.depot.name}}
  </div>
  <div class="table-td-lite w200 invoice-right-action">
    {{ (isApproved) ? Number(payment.client.total_amount).toFixed(2) :
      Number(payment.transporter.total_amount).toFixed(2)}}
  </div>
</div>
</template>

<script>
export default {
  props: {
    payment: {
      type: Object,
    },
  },
  components: {},
  computed: {
    isApproved() {
      return (this.$store.invoice && this.$store.invoice.status) ?
        this.$store.invoice.status >= 3 : false;
    },
  },
};
</script>

<style lang="scss">

</style>
